import companiesActions from './actions';
import storeResourceFactory from '../../libs/storeResourceFactory';

const companiesStore = storeResourceFactory('companies', {});

const state = {
  ...companiesStore.state,
};

const actions = {
  initializeCompanies: companiesStore.request(companiesActions.initializeCompanies),
};

const mutations = {
  ...companiesStore.mutations,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/companies/index.js